export enum ImportExportType {
  STOPS = 'stops',
  GEOJSON = 'geojson',
  KML = 'kml',
  KMZ = 'kmz',
}
